/**
 * Slugged role for client users, from Django via /nexus/me/.
 * Only 'project_manager' and 'analyst' restrict access; 'admin' (or a
 * missing/null value, e.g. from an older backend) means unrestricted.
 * Always null for non-client users.
 */
export type ClientRole = 'admin' | 'project_manager' | 'analyst';

export interface User {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  isClient?: boolean;
  isNetworkPartner?: boolean;
  isAdministrator?: boolean;
  teamId?: number;
  clientRole?: ClientRole | null;
}

/**
 * The most junior client role: pricing is hidden and screening cannot
 * be started by them. Any other combination (client admins, missing
 * role from an older backend, GTI users) is NOT treated as analyst.
 */
export function isClientAnalyst(user: User | null | undefined): boolean {
  return !!user?.isClient && user.clientRole === 'analyst';
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<void>;
  logout: () => Promise<void>;
  error: string | null;
}
